module.exports = __webpack_public_path__ + "static/media/Background.c79c1c46.svg";